import { cloneDeep } from 'lodash';
import { validateClosingTime } from './validate-closing-time.handle';
import { openCloseHandle } from './validate-open-close.handle';

export const transformSchedule = ({ formObject, data, coordinates }) => {
	try {
		const originalData = cloneDeep(data);
		const _formObject = { ...formObject };
		_formObject.schedule.forEach((iterator) => {
			if (!validateClosingTime({ schedule: iterator })) {
				throw new Error('Error [validateClosingTime]');
			}

			if (!openCloseHandle({ schedule: iterator })) {
				throw new Error('Error [openCloseHandle]');
			}
		});

		_formObject.phone = _formObject.phone.replaceAll(/[+\s-]/g, '');
		_formObject._geoloc = coordinates;

		const newPharmacyLocal = { ...originalData, ..._formObject };
		delete newPharmacyLocal._id;
		delete newPharmacyLocal.city;
		delete newPharmacyLocal.point_location;
		return newPharmacyLocal;
	} catch (e) {
		console.log('error: ', e);
		throw e;
	}
};
